import { useEffect, useMemo, useState } from "react";
import { useScreenClass } from "react-grid-system";
import { Controller, SubmitHandler, useForm } from "react-hook-form";
import styled from "styled-components";
import theme from "../styles/theme";
import Button from "./Button";
import CompetencyModal from "./CompetencyModal";
import FlexBox, { FlexGrow } from "./FlexBox";
import Icon, { ClickableIcon } from "./Icon";
import Input, { InputTextArea } from "./Input";
import MinimalSelect from "./MinimalSelect";
import Modal from "./Modal";
import { StyledText, TextSize, TextStatus } from "./Text";
import TopicListModal from "./TopicListModal";
import { TOption } from "../types/Options";
import axios from "axios";

const Header = styled.h4`
  font-size: 20px;
  font-style: normal;
  // font-weight: 700;
  line-height: 28px;
  letter-spacing: 0px;
  text-align: left;
`;
const CustomFlex = styled(FlexBox)`
  padding: 20px 0;
  align-items: center;
  border-bottom: 1px solid #3c406c;
`;
const CustomFlexPlain = styled(FlexBox)`
  padding: 10px 0;
  align-items: flex-start;
`;
const CustomGrowPlain = styled(FlexGrow)`
  min-width: 150px;
  flex-grow: 0;
`;
const Label = styled.h6`
  // font-size: 16px;
  font-style: normal;
  font-weight: normal;
  line-height: 24px;
  letter-spacing: 0px;
  text-align: left;
`;
type ModifySkillModalProps = {
  onSubmit: any;
  isOpen?: boolean;
  data: any;
  header: string;
  mode: "modify" | "create";
  setOpen: (x: boolean) => void;
};
interface SkillwInputs {
  skill_title: string;
  skill_description: string;
  assessment_description: string;
  complexity_level: {};
  knowledge_topic: { name: string; id: string };
  assessment_type_id: number;
  computing_slo: string | number;
  engineering_slo: string | number;
}

interface IOptions {
  value: number | string;
  label: string;
}
const ModifySkillModal = ({
  onSubmit,
  isOpen,
  setOpen,
  header,
  mode,
  data,
}: ModifySkillModalProps): JSX.Element => {
  const screenClass = useScreenClass();
  const [openTopic, setOpenTopic] = useState<boolean>(false);
  const {
    register,
    handleSubmit: handleSubmitSkills,
    control,
    watch,
    reset,
    setValue,
    formState: { errors },
  } = useForm<SkillwInputs>({
    mode: "onBlur",
    defaultValues: {
      skill_title: data.skill.title || "",
      skill_description: data.skill.description || "",
      assessment_description: data.assessment
        ? data.assessment.description
        : "",
      assessment_type_id: data.assessment.assessment_type_id,
      engineering_slo: data.engineering_slo,
      computing_slo: data.computing_slo,
      complexity_level: data.skill.cognitive_level,
    },
  });
  console.log("daata is", data);
  useEffect(() => {
    fetchAssessmentTypes();
    fetchLearningOutcome();
    fetchCognitiveSkill();
  }, []);

  const [optionsType, setOptionType] = useState<IOptions[]>([]);
  const [optionsEng, setOptionEng] = useState<IOptions[]>([]);
  const [optionsComp, setOptionComp] = useState<IOptions[]>([]);
  const [optionsSkill, setOptionSkill] = useState<IOptions[]>([]);
  const onSubmitSkills: SubmitHandler<SkillwInputs> = (fdata: any) => {
    // console.log(fdata, data);
    onSubmit(fdata, data);
  };
  const fetchAssessmentTypes = () => {
    axios
      .get("/assessmenttype")
      .then((res: any) => {
        const optionFormat: any = [];
        res.data.assessmen_types?.map((v: any) =>
          optionFormat.push({ label: v.title, value: v.id })
        );
        setOptionType(optionFormat);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };
  const fetchLearningOutcome = () => {
    axios
      .get("/learningoutcome")
      .then((res: any) => {
        if (res.data.learning_outcomes) {
          const optionFormatEng: any = [];
          res.data.learning_outcomes?.engineering_slo?.map((v: any) =>
            optionFormatEng.push({ label: v.title, value: v.id })
          );
          setOptionEng(optionFormatEng);

          const optionFormatCom: any = [];
          res.data.learning_outcomes?.computing_slo?.map((v: any) =>
            optionFormatCom.push({ label: v.title, value: v.id })
          );
          setOptionComp(optionFormatCom);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };
  const fetchCognitiveSkill = () => {
    axios
      .get("/cognitiveskill")
      .then((res: any) => {
        const optionFormat: any = [];
        res.data.cognitiveskills?.map((v: any) =>
          optionFormat.push({ label: v.title, value: v.id })
        );
        optionFormat.sort((a: any, b: any) => a.value - b.value);
        // console.log(optionFormat);
        setOptionSkill(optionFormat);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  return (
    <>
      <TopicListModal
        isOpen={openTopic}
        setOpen={setOpenTopic}
        onTopicSelected={(data) => {
          setValue("knowledge_topic", data);
          setOpenTopic(false);
        }}
      />
      <Modal
        isOpen={isOpen || false}
        setOpen={setOpen}
        customStyle={{
          overlay: {
            zIndex: "999958",
          },
          content: {
            marginTop: 10,
            maxWidth: "900px",
            padding: "0 24px",
            color: "black",
            background: "#FFFFFF",
            border: "1px solid #E7EBEE",
            boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.07)",
            borderRadius: "8px",
            top: 0,
          },
        }}
      >
        <form onSubmit={handleSubmitSkills(onSubmitSkills)}>
          <CustomFlex>
            <FlexGrow>
              <Header>{header}</Header>
            </FlexGrow>
            <ClickableIcon
              size={3.125}
              fixedWidth={false}
              color="black"
              name="close"
              onClick={() => setOpen(false)}
            />
          </CustomFlex>
          <CustomFlex
            style={{
              position: "relative",
              borderBottom: "none",
              alignItems: "flex-start",
              overflowY: "scroll",
              overflowX: "hidden",
              padding: 10,
            }}
          >
            <FlexGrow>
              <CustomFlexPlain>
                <CustomGrowPlain>
                  <Label>Topic:</Label>
                </CustomGrowPlain>
                <FlexGrow>
                  {mode === "modify" ? (
                    <StyledText
                      textSize={TextSize.sidebar}
                      status={TextStatus.muted}
                    >
                      {data.skill.topic_title || "-"}
                    </StyledText>
                  ) : (
                    <>
                      {watch().knowledge_topic &&
                      watch().knowledge_topic.name !== "" ? (
                        <>
                          <StyledText>
                            {watch().knowledge_topic?.name}
                          </StyledText>
                          <ClickableIcon
                            style={{
                              verticalAlign: "bottom",
                              color: "red",
                              marginLeft: "5px",
                            }}
                            name={"close"}
                            onClick={() => {
                              setValue("knowledge_topic", { name: "", id: "" });
                            }}
                          />
                        </>
                      ) : (
                        <Button
                          style={{ border: "2px solid #64748B" }}
                          onClick={() => {
                            setOpenTopic(true);
                          }}
                        >
                          <Icon mr={1} name="add_circle_outline" />
                          Choose
                        </Button>
                      )}
                    </>
                  )}
                </FlexGrow>
              </CustomFlexPlain>

              {data.assessed_skill_code && (
                <CustomFlexPlain>
                  <CustomGrowPlain>
                    <Label>Skill Code</Label>
                  </CustomGrowPlain>
                  <FlexGrow>
                    <StyledText
                      style={{ color: "#505050", paddingRight: "5px" }}
                    >
                      {data.assessed_skill_code}
                    </StyledText>
                  </FlexGrow>
                </CustomFlexPlain>
              )}

              <CustomFlexPlain>
                <CustomGrowPlain>
                  <Label>Skill Title</Label>
                </CustomGrowPlain>
                <FlexGrow>
                  <Input
                    disabled={header === "Skill Detail"}
                    style={{ width: "100%" }}
                    isFullWidth
                    {...register("skill_title", { required: true })}
                  />
                </FlexGrow>
              </CustomFlexPlain>

              <CustomFlexPlain>
                <CustomGrowPlain>
                  <Label>Description</Label>
                </CustomGrowPlain>
                <FlexGrow>
                  <InputTextArea
                    disabled={header === "Skill Detail"}
                    maxLength={2048}
                    style={{ width: "100%" }}
                    isFullWidth
                    {...register("skill_description")}
                  />
                </FlexGrow>
              </CustomFlexPlain>
              <CustomFlexPlain>
                <CustomGrowPlain>
                  <Label>Assessment Description</Label>
                </CustomGrowPlain>
                <FlexGrow>
                  <InputTextArea
                    disabled={header === "Skill Detail"}
                    maxLength={2048}
                    style={{ width: "100%" }}
                    isFullWidth
                    {...register("assessment_description")}
                  />
                </FlexGrow>
              </CustomFlexPlain>
              <CustomFlexPlain>
                <CustomGrowPlain>
                  <Label>Assessment Type</Label>
                </CustomGrowPlain>
                <FlexGrow>
                  <Controller
                    name="assessment_type_id"
                    control={control}
                    render={({ field }) => (
                      <>
                        <MinimalSelect
                          isDisabled={header === "Skill Detail"}
                          {...field}
                          value={optionsType.find(
                            (c) => c.value === field.value
                          )}
                          onChange={(item: TOption | unknown) => {
                            const val = item as TOption;
                            field.onChange(val.value as string);
                          }}
                          styles={{
                            container: (base) => ({
                              ...base,
                              width: "100%",
                              maxWidth: "100%",
                            }),
                            menuPortal: (base) => ({
                              ...base,
                              zIndex: 9999,
                              color: theme.color.lightBlueGray800,
                            }),
                          }}
                          options={optionsType}
                        />
                      </>
                    )}
                  />
                </FlexGrow>
              </CustomFlexPlain>
              <CustomFlexPlain>
                <CustomGrowPlain>
                  <Label>Complexity Level:</Label>
                </CustomGrowPlain>
                <FlexGrow>
                  <Controller
                    name="complexity_level"
                    control={control}
                    render={({ field }) => (
                      <MinimalSelect
                        isDisabled={header === "Skill Detail"}
                        required
                        {...field}
                        value={optionsSkill?.find(
                          (c) => c.value === field.value
                        )}
                        onChange={(item: TOption | unknown) => {
                          const val = item as TOption;
                          field.onChange(val.value as string);
                        }}
                        name={field.name}
                        options={optionsSkill}
                        styles={{
                          container: (base) => ({
                            ...base,
                            width: "100%",
                            maxWidth: "100%",
                          }),
                          menuPortal: (base) => ({
                            ...base,
                            zIndex: 9999,
                            color: theme.color.lightBlueGray800,
                          }),
                        }}
                      />
                    )}
                  />
                </FlexGrow>
              </CustomFlexPlain>
              <CustomFlexPlain>
                <CustomGrowPlain>
                  <Label>Engineering SLO:</Label>
                </CustomGrowPlain>
                <FlexGrow>
                  <Controller
                    name="engineering_slo"
                    control={control}
                    render={({ field }) => (
                      <MinimalSelect
                        isDisabled={header === "Skill Detail"}
                        isClearable={false}
                        isMulti
                        required
                        {...field}
                        defaultValue={data?.engineering_slo?.map((f: any) => ({
                          value: f.id,
                          label: f.title,
                        }))}
                        value={optionsType?.find(
                          (c) => c.value === field?.value
                        )}
                        onChange={(selectedOptions: any) => {
                          field.onChange(selectedOptions);
                        }}
                        name={field.name}
                        options={optionsEng}
                        styles={{
                          container: (base) => ({
                            ...base,
                            width: "100%",
                            maxWidth: "100%",
                          }),
                          menuPortal: (base) => ({
                            ...base,
                            zIndex: 9999,
                            color: theme.color.lightBlueGray800,
                          }),
                        }}
                      />
                    )}
                  />
                </FlexGrow>
              </CustomFlexPlain>
              <CustomFlexPlain>
                <CustomGrowPlain>
                  <Label>Computing SLO:</Label>
                </CustomGrowPlain>
                <FlexGrow>
                  <Controller
                    name="computing_slo"
                    control={control}
                    render={({ field }) => (
                      <MinimalSelect
                        isDisabled={header === "Skill Detail"}
                        isClearable={false}
                        isMulti
                        required
                        {...field}
                        defaultValue={data?.computing_slo?.map((f: any) => ({
                          value: f.id,
                          label: f.title,
                        }))}
                        value={optionsType?.find(
                          (c) => c.value === field.value
                        )}
                        onChange={(selectedOptions: any) => {
                          field.onChange(selectedOptions);
                        }}
                        name={field.name}
                        options={optionsComp}
                        styles={{
                          container: (base) => ({
                            ...base,
                            width: "100%",
                            maxWidth: "100%",
                          }),
                          menuPortal: (base) => ({
                            ...base,
                            zIndex: 9999,
                            color: theme.color.lightBlueGray800,
                          }),
                        }}
                      />
                    )}
                  />
                </FlexGrow>
              </CustomFlexPlain>
              <FlexBox>
                <FlexGrow></FlexGrow>
                <Button
                  onClick={() => setOpen(false)}
                  style={{
                    border: "2px solid #64748B",
                    padding: "8px 40px",
                    fontSize: "14px",
                  }}
                >
                  Cancel
                </Button>
                <Button
                  disabled={header === "Skill Detail"}
                  type="submit"
                  style={{
                    // border: "2px solid #64748B",
                    padding: "8px 40px",
                    backgroundColor: "#0061ff",
                    boxShadow: "0 0 5px gray",
                    border: "none",
                    color: "white",
                    fontSize: "14px",
                  }}
                >
                  Save
                </Button>
              </FlexBox>
            </FlexGrow>
          </CustomFlex>
        </form>
      </Modal>
    </>
  );
};

export default ModifySkillModal;
